export default "/imgs/logo/brand-image-250.png"